import { Outlet } from "react-router-dom";

export const HeaderFixedLayout = () => {
  return (
    <>
      <div className="headerFixedLayout">
        <Outlet />
      </div>
    </>
  );
};
